var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.imgUrlList),function(url){return _c('div',{key:url,staticClass:"img-box"},[_c('img',{staticClass:"asset-main-img",attrs:{"src":"","data-img":url}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }